import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation createSubjectDoctorLog($data: createSubjectDoctorLogInput!) {
    createSubjectDoctorLog(data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const createSubjectDoctorLogRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {data: TYPES.CreateSubjectDoctorLogInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'subject_doctor_log/create_subject_doctor_log',
  async (
  params: {data: TYPES.CreateSubjectDoctorLogInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.createSubjectDoctorLog;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const createSubjectDoctorLogSlice = createSlice({
  name: 'create_subject_doctor_log',
  initialState: initialState,
  reducers: {
    createSubjectDoctorLogClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(createSubjectDoctorLogRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(createSubjectDoctorLogRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(createSubjectDoctorLogRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { createSubjectDoctorLogClear } =
createSubjectDoctorLogSlice.actions;

export const createSubjectDoctorLog = createSelector(
  (state: RootState) =>
  state.subjectDoctorLog.createSubjectDoctorLog.result,
  (state: RootState) =>
  state.subjectDoctorLog.createSubjectDoctorLog.error,
  (state: RootState) =>
  state.subjectDoctorLog.createSubjectDoctorLog.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default createSubjectDoctorLogSlice.reducer;